export const environment = {
  production: false,
  baseHref: '/',
  redirectUri: 'https://newptm.johnsands.com/',
  postLogoutRedirectUri: 'https://newptm.johnsands.com/',
  webApi: 'https://newptm-api.johnsands.com',
  tablePaginationSizes: [10, 25, 100],
  pageableAllItems: 99999,
  noLoadingSpinnerHeader: 'loading-spinner-disabled',
  httpRequestChunkSize: 100
};
